import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { defineMessages, FormattedMessage, useIntl } from "react-intl";
import clsx from "clsx";
import { PendingIconButton } from "@ploy-ui/core";
import { IconButton, InputAdornment, Toolbar, Tooltip, Typography } from "@material-ui/core";
import { lighten, makeStyles } from "@material-ui/core/styles";
import ClearIcon from "@material-ui/icons/Clear";
import DeleteIcon from "@material-ui/icons/Delete";
import SearchIcon from "@material-ui/icons/Search";
import { DployTextField } from "@ploy-ui/form-fields";
const messages = defineMessages({
    search: {
        id: "dploy.template-form.table-section.search.placeholder",
        descrption: "Search",
        defaultMessage: "Søk"
    }
});
const useToolbarStyles = makeStyles(theme => ({
    root: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1)
    },
    highlight: theme.palette.type === "light"
        ? {
            color: theme.palette.secondary.main,
            backgroundColor: lighten(theme.palette.secondary.light, 0.85)
        }
        : {
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.secondary.dark
        },
    title: {
        flex: "1 1 100%"
    }
}));
export function TableToolbar(props) {
    const classes = useToolbarStyles();
    const { numSelected = 0, title, searchValue = "", canDelete, onSearch, onDelete, canNextPage } = props;
    const intl = useIntl();
    return (_jsxs(Toolbar, { className: clsx(classes.root, {
            [classes.highlight]: numSelected > 0
        }), children: [canNextPage && numSelected > 0 ? (_jsx(Typography, { className: classes.title, color: "inherit", variant: "subtitle1", component: "div", children: _jsx(FormattedMessage, { id: "dploy.template-form.table-section.selected.title", description: "{numSelected} selected", defaultMessage: "{numSelected} valgt", values: { numSelected } }) })) : (_jsx(Typography, { className: classes.title, variant: "h6", id: "tableTitle", component: "div", children: title })), numSelected > 0 && canDelete ? (_jsx(Tooltip, { title: "Delete", children: _jsx(PendingIconButton, { "aria-label": "delete", onClick: onDelete, success: false, error: false, children: _jsx(DeleteIcon, {}) }) })) : onSearch ? (_jsx(DployTextField, { placeholder: intl.formatMessage(messages.search), value: searchValue, onChange: e => onSearch(e.target.value), InputProps: {
                    endAdornment: (_jsx(InputAdornment, { position: "end", children: searchValue === "" ? (_jsx(IconButton, { children: _jsx(SearchIcon, {}) })) : (_jsx(IconButton, { onClick: () => onSearch(""), children: _jsx(ClearIcon, {}) })) }))
                } })) : null] }));
}
//# sourceMappingURL=TableToolbar.js.map